export default [
  {
    path: "/join-contest/:contest_code",
    name: "Join contest",
    component: () => import("@/app/modules/contests/pages/join.component.vue"),
  },
];
